import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export function initializeTelemetry(connectionString: string | undefined): void {
    if (!connectionString) {
        return;
    }

    const appInsights = new ApplicationInsights({
        config: {
            connectionString,
            enableAutoRouteTracking: true,
        },
    });

    appInsights.loadAppInsights();
    appInsights.addTelemetryInitializer((envelope) => {
        envelope.tags = envelope.tags ?? {};
        envelope.tags['ai.cloud.role'] = 'em2-portal';
    });
    appInsights.trackPageView();
}
